import { Box, IconButton, Typography } from "@mui/material";
import { ReactNode } from "react";
import theme, { responsiveFontSize } from "themes/Theme";

interface IProps {
  title: string;
  icon: ReactNode;
  onIconClick?: () => void;
}

const AdminPageCardTitle: React.FC<IProps> = ({ title, icon, onIconClick }) => {
  return (
    <Box sx={styles.cardTitleContainer}>
      {onIconClick ? (
        <IconButton onClick={onIconClick}>{icon}</IconButton>
      ) : (
        icon
      )}

      <Typography sx={styles.cardTitle}>{title}</Typography>
    </Box>
  );
};
export default AdminPageCardTitle;
const styles = {
  cardTitleContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 1,
    color: theme.palette.primary.main,
  },
  cardTitle: {
    fontSize: responsiveFontSize(18),
    fontWeight: 500,
    color: theme.palette.primary.main,
  },
};
